export const environment = {
  production: true,
  apiUrl : "https://qa4-agency.np.flydubai.com/api",
  taPortal : "https://qa4-ta.np.flydubai.com/en/User/Signout",
  taLink : "https://qa4-ta.np.flydubai.com/en/user/signin",
  timeoutMinute : 30
};


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/environments/environment.ts